import { render, staticRenderFns } from "./Manufacturer.vue?vue&type=template&id=5df7d912&scoped=true&"
import script from "./Manufacturer.vue?vue&type=script&lang=js&"
export * from "./Manufacturer.vue?vue&type=script&lang=js&"
import style0 from "./Manufacturer.vue?vue&type=style&index=0&id=5df7d912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7d912",
  null
  
)

export default component.exports